/**
 * Created by dushyantha on 9/22/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewing.factory:crewProfileDTOFactory
     *
     * @description
     *
     */
    angular
        .module('crewProfile')
        .factory('crewProfileDTOFactory', crewProfileDTOFactory);

    function crewProfileDTOFactory() {

        var personalInfoDTO = function () {
            this.firstName = '',
                this.middleName = '',
                this.lastName = '',
                this.lastNameWithInitials = '',
                this.callName = '',
                this.religion = '',
                this.civilStatus = {name: ''},
                this.gender = {code: '', description: ''},
                this.dob = '',
                this.status = false,
                this.trainee = false,
                this.traineeStartDate = null,
                this.traineeEndDate = null,
                this.seniorPilot = false,
                this.blueLine = false,
                this.otherHub = false,
                this.coverPilotRequired = false,
                this.lvp = false,
                this.trn = false,
                this.etop = false,
                this.rhs = false,
                this.crewOperType = {operTypeDesc:'',operTypeCode:''}
            	this.flying = false;
        };

        var crewInfoDTO = function () {
                this.crewId = '',
                this.crewTypeCode = {crewTypeCode: ''},
                this.group = {groupName: '', groupCode: ''},
                this.batchCode = {description: '', crewBatchCode: ''},
                this.boxNumber = '',
                this.uId = '',
                this.newStaffId = '',
                this.alvGroups = {alvGroupCode: ''},
                this.ucid = '';

        };

        var employmentInfoDTO = function () {
                this.dateOfContract = '',
                this.flexiDateOfContract = '',
                this.dateOfJoin = '',
                this.crewBase = {airPortCode:''},
                this.passportDateOfIssue = '',
                this.passportNumber = '',
                this.passportDateOfExpiry = '',
                this.nationalityCode={code:'',description:''},
                this.crewPosition={crewPositionDesc:'',crewPositionCode:'',startDate:'',endDate:''},
                this.crewPositionList= [],
                this.lastWorkingDay= '',
                this.civilId = '',
                this.alvCount = null,
                this.employerHub = {hubCode: ''},
                this.contractInfo = {contractCode: '', contractDescription: ''}
                this.designation = {designationId: '', designation: ''}
        };

        var webAccessDTO = function () {
                this.loginId = '';
                this.password = '';
                this.confirmPassword = '';
                this.roles = [];
                this.initiallyLoadedPassword = '';

        };

        var passwordInfoDTO =function(){
                this.passwordInfo = {ciphertext:null, salt:null, iv:null}
        };

        var primaryContactDTO = function(){
                this.residenceAddLine1 = '',
                this.residencePostalCode = '',
                this.stateProvience = '',
                this.primaryResidenceNo = '',
                this.primaryBusinessNo = '',
                this.primaryMobileNo='',
                this.primaryEmail='',
                this.swapContact=''
        };

        var secondaryContactDTO = function () {
                this.secondaryResidenceNo = '',
                this.secondaryBusinessNo='',
                this.secondaryMobileNo='',
                this.secondaryEmail=''

        };
        var kinContactDTO = function () {
                this.kinName = '',
                this.kinRelationship = '',
                this.kinAddLine1 = '',
                this.kinMobileNo= ''
        };
        var traineeTypeInfoDTO = function () {
                this.dateOfTrainerStart='';
                this.trainerTypeCodeList=[];
        };
        var fleetExperienceDTO = function () {
                this.crewTypeCode={crewTypeCode:''};
                this.modelNumber={modelNumber:''};
                this.flying=false;
                this.fleetExperienceId="";
                this.version=null;
                this.fleetClearanceDate=null;
                this.blueLine = {
                    enabled: false,
                    enabled_old:false,
                    startDate: null,
                    startDate_old:null,
                    startTime: null,
                    endDate: null,
                    endTime:null
                }
        };
        var crewBaseAssignmentDTO = function () {
            this.crewBaseAssignmentId = "";
            this.crewProfileId = "";
            this.effectiveFromDate = "";
            this.effectiveToDate = "";
            this.crewBase = {airPortCode:''};
            this.employerHub = {hubCode: ''};
            this.postingType = {value: '', label: ''};
            this.remarks = null;
            this.version = null;
        };


      var crewDateRangeForPositionDTO = function () {
        this.dateOfStart ="";
        this.dateOfEnd ="";
      };
        var crewUpgradeDTO = function () {
                this.crewTypeDetails={crewTypeCode:''};
                this.localDateTime='';
                this.version=0;
                this.crewProfileUpgradeId = null;
                this.crewProfCrewTypeChanged = false;
                this.isBlueLine=false;
                this.blueLineStartDate=null;
                this.blueLineStartTime=null;
                this.blueLineEndedDate= null;
                this.blueLineEndedTime=null;
                this.recencyClearanceDate=null;
        };

        var crewTrainingStageDTO = function () {
          this.crewTypeStageId=0;
          this.stageName=null;
          this.crewTypeCode=null;
          this.status=null;
          this.instructorsDataList=[];
          this.instructors=[];
          this.stageSequenceOrder=0;
          this.stageVersion=0;
        };

        var hoursDataDTO = function () {
            this.crewProfileId = '',
            this.fromDate = '',
            this.toDate = '',
            this.flyingHoursInHHMI = '000:00',
            this.dutyHoursInHHMI = '000:00',
            this.carrierCodeDetails = {'hubCode':'',
                'hubDesc':''},
            this.carrier = {'hubCode':'',
                        'hubDesc':''},
            this.crewHubFlyingHoursId = '',
            this.version = null,
            this.hoursDetailsChange = false,
            this.otherHubCrewId = null;
        };

        var preferenceDataDTO = function () {
            this.crewProfileId = '',
            this.fromDate = '',
            this.toDate = '',
            this.remarks = '',
            this.hotelNotReq = '',
            this.station = '',
            this.version = null,
            this.crewLayoverAccommodationPrefId = null;
        };

        var importHoursDataDTO = function () {
            this.crewProfileId = '',
            this.fromDate = '',
            this.toDate = '',
            this.carrier = {'hubCode':'',
                'hubDesc':''},
            this.otherHubCrewId = null;
        };

        var crewDefaultValidationDTO = function () {
            this.crewProfileId = '';
            this.defaultValidationIds = [];
            this.defaultValidationCodes = [];
        };

        var languageSkillDTO = function (code,name) {
            this.crewProfileId = null;
            this.languageSkillId = null;
            this.languageCode = code;
            this.languageName = name;
            this.effectiveFromDate = null;
            this.effectiveToDate = null;
            this.status = 'ACT';
        }

        var crewACMIAssignmentDTO = function () {
          this.crewProfileId = null;
          this.effectiveAcmiFromDate = null;
          this.effectiveAcmiToDate = null;
          this.acmiEndDateStr = null;
          this.acmiEndDate = null;
          this.crewAcmiRangeId = null;
        }

        var editSaveACMIRangesRequestDTO = function () {
          this.crewProfileId = null;
          this.editedAcmiRanges = [];
        }


        var deleteACMIRangesRequestDTO = function () {
          this.crewProfileId = null;
          this.acmiRangeId = null;
        }



        function LanguageSkill() {
            this.crewProfileId = null;
            this.languageSkillId = null;
            this.languageCode = null;
            this.languageName = name;
            this.effectiveFromDate = null;
            this.effectiveToDate = null;
            this.status = 'ACT';
        }

        function FlyRangePaymentDetail(param) {
        	this.paymentHourRangeCrewId = (!!param && !!param.paymentHourRangeCrewId) ? param.paymentHourRangeCrewId : null;
        	this.version = (!!param && (!!param.version || param.version == 0)) ? param.version : null;
        	this.crewProfileId = (!!param && !!param.crewProfileId) ? param.crewProfileId : null;
        	this.rangeTitle = (!!param && !!param.rangeTitle) ? param.rangeTitle : null;
        	this.rangeStartHour = (!!param && (!!param.rangeStartHour || param.rangeStartHour == 0)) ? param.rangeStartHour : null;
        	this.rangeEndHour = (!!param && (!!param.rangeEndHour || param.rangeEndHour == 0)) ? param.rangeEndHour : null;
        	this.flyHourRate = (!!param && !!param.flyHourRate) ? param.flyHourRate : 0;
        }

        function FlyRangePaymentDeleteRq(param) {
        	this.paymentHourRangeCrewId = (!!param && !!param.paymentHourRangeCrewId) ? param.paymentHourRangeCrewId : null;
        	this.version = (!!param && (!!param.version || param.version == 0)) ? param.version : null;
        }

        function CrewOtherPaymentDetail(param){
        	this.paymentRateId = (!!param && !!param.paymentRateId) ? param.paymentRateId : null;
        	this.crewProfileId = (!!param && !!param.crewProfileId) ? param.crewProfileId : null;

        	this.duty1 = (!!param && !!param.duty1) ? Number(param.duty1) : null;
        	this.offRate = (!!param && !!param.offRate) ? Number(param.offRate) : null;
        	this.cmbRate = (!!param && !!param.cmbRate) ? Number(param.cmbRate) : null;
        	this.ltRate = (!!param && !!param.ltRate) ? Number(param.ltRate) : null;
        	this.simRate = (!!param && !!param.simRate) ? Number(param.simRate) : null;
        	this.calledFromOffRate = (!!param && !!param.calledFromOffRate) ? Number(param.calledFromOffRate) : null;
        	this.grdRate = (!!param && !!param.grdRate) ? Number(param.grdRate) : null;
        	this.MaxPayOfficeDutyRate =(!!param && !!param.maxPayOfcDutyRate) ? Number(param.maxPayOfcDutyRate) : null;
        	this.domesticNightStopRate = (!!param && !!param.domesticNightStopRate) ? Number(param.domesticNightStopRate) : null;
          this.internationalNightStopRate = (!!param && !!param.internationalNightStopRate) ? Number(param.internationalNightStopRate) : null;
          this.hourlyDomesticNightStopRate = (!!param && !!param.hourlyDomesticNightStopRate) ? Number(param.hourlyDomesticNightStopRate) : null;
          this.hourlyInternationalNightStopRate = (!!param && !!param.hourlyInternationalNightStopRate) ? Number(param.hourlyInternationalNightStopRate) : null;
          this.hourlyDomesticPerDiemRate = (!!param && !!param.hourlyDomesticPerDiemRate) ? Number(param.hourlyDomesticPerDiemRate) : null;
          this.hourlyInternationalPerDiemRate = (!!param && !!param.hourlyInternationalPerDiemRate) ? Number(param.hourlyInternationalPerDiemRate) : null;

        	//this.dhtRate = (!!param && !!param.dhtRate) ? Number(param.dhtRate) : null;
        	//this.heavyFlyingRate = (!!param && !!param.heavyFlyingRate) ? Number(param.heavyFlyingRate) : null;
          this.MaxPayOfficeDutyHoursPerDay = (!!param && !!param.maxPayOfficeDutyHoursPerDay) ? Number(param.maxPayOfficeDutyHoursPerDay) : null;
          this.groundTrainingRatePerDay = (!!param && !!param.groundTrainingRatePerDay) ? Number(param.groundTrainingRatePerDay) : null;
          this.CabinSpecialDutyPerHour = (!!param && !!param.cabinSpecialDutyRate) ? Number(param.cabinSpecialDutyRate) : null;
          this.CabinSupportActivityPerHour = (!!param && !!param.cabinSupportActivityRate) ? Number(param.cabinSupportActivityRate) : null;

        	this.lT_LTC_LESS_EXP_Rate = (!!param && !!param.lT_LTC_LESS_EXP_Rate) ? Number(param.lT_LTC_LESS_EXP_Rate) : null;
        	this.lT_LTC_MORE_EXP_Rate = (!!param && !!param.lT_LTC_MORE_EXP_Rate) ? Number(param.lT_LTC_MORE_EXP_Rate) : null;
        	this.lT_TRI_MORE_EXP_Rate = (!!param && !!param.lT_TRI_MORE_EXP_Rate) ? Number(param.lT_TRI_MORE_EXP_Rate) : null;
        	this.lT_TRI_LESS_EXP_Rate = (!!param && !!param.lT_TRI_LESS_EXP_Rate) ? Number(param.lT_TRI_LESS_EXP_Rate) : null;
        	this.lT_TRE_LESS_EXP_Rate = (!!param && !!param.lT_TRE_LESS_EXP_Rate) ? Number(param.lT_TRE_LESS_EXP_Rate) : null;
        	this.lT_TRE_MORE_EXP_Rate = (!!param && !!param.lT_TRE_MORE_EXP_Rate) ? Number(param.lT_TRE_MORE_EXP_Rate) : null;

        	this.sIM_SFI_LESS_EXP_Rate = (!!param && !!param.sIM_SFI_LESS_EXP_Rate) ? Number(param.sIM_SFI_LESS_EXP_Rate) : null;
        	this.sIM_SFI_MORE_EXP_Rate = (!!param && !!param.sIM_SFI_MORE_EXP_Rate) ? Number(param.sIM_SFI_MORE_EXP_Rate) : null;
        	this.sIM_TRI_LESS_EXP_Rate = (!!param && !!param.sIM_TRI_LESS_EXP_Rate) ? Number(param.sIM_TRI_LESS_EXP_Rate) : null;
        	this.sIM_TRI_MORE_EXP_Rate = (!!param && !!param.sIM_TRI_MORE_EXP_Rate) ? Number(param.sIM_TRI_MORE_EXP_Rate) : null;
        	this.sIM_TRE_MORE_EXP_Rate = (!!param && !!param.sIM_TRE_MORE_EXP_Rate) ? Number(param.sIM_TRE_MORE_EXP_Rate) : null;
        	this.sIM_TRE_LESS_EXP_Rate = (!!param && !!param.sIM_TRE_LESS_EXP_Rate) ? Number(param.sIM_TRE_LESS_EXP_Rate) : null;

        	this.mFTD_MORE_EXP_Rate = (!!param && !!param.mFTD_MORE_EXP_Rate) ? Number(param.mFTD_MORE_EXP_Rate) : null;
        	this.mFTD_LESS_EXP_Rate = (!!param && !!param.mFTD_LESS_EXP_Rate) ? Number(param.mFTD_LESS_EXP_Rate) : null;

        	this.airPortSbyRate = (!!param && !!param.airPortSbyRate) ? Number(param.airPortSbyRate) : null;
        	this.leaveDays = (!!param && !!param.leaveDays) ? Number(param.leaveDays) : null;
        	this.sod = (!!param && !!param.sod) ? Number(param.sod) : null;
        	this.adHocPay = (!!param && !!param.adHocPay) ? Number(param.adHocPay) : null;

        	this.version = (!!param && (!!param.version || param.version == 0 )) ? param.version : null;
        }


        function CrewOtherPaymentDetailRQ(param){
        	this.paymentRateId = (!!param && !!param.paymentRateId) ? param.paymentRateId : null;
        	this.crewProfileId = (!!param && !!param.crewProfileId) ? param.crewProfileId : null;

        	this.duty1 = (!!param && param.duty1 !== null) ? param.duty1.toString() : null;
        	this.offRate = (!!param && param.offRate !== null) ? param.offRate.toString() : null;
        	this.cmbRate = (!!param && param.cmbRate !== null) ? param.cmbRate.toString() : null;
        	this.ltRate = (!!param && param.ltRate !== null) ? param.ltRate.toString() : null;
        	this.simRate = (!!param && param.simRate !== null) ? param.simRate.toString() : null;
        	this.calledFromOffRate = (!!param && param.calledFromOffRate !== null) ? param.calledFromOffRate.toString() : null;
        	this.grdRate = (!!param && param.grdRate !== null) ? param.grdRate.toString() : null;
        	this.maxPayOfcDutyRate = (!!param && param.MaxPayOfficeDutyRate !== null) ? param.MaxPayOfficeDutyRate.toString() : null;
        	this.domesticNightStopRate = (!!param && param.domesticNightStopRate !== null) ? param.domesticNightStopRate.toString() : null;
          this.internationalNightStopRate = (!!param && param.internationalNightStopRate !== null) ? param.internationalNightStopRate.toString() : null;
          this.hourlyDomesticNightStopRate = (!!param && param.hourlyDomesticNightStopRate !== null) ? param.hourlyDomesticNightStopRate.toString() : null;
          this.hourlyInternationalNightStopRate = (!!param && param.hourlyInternationalNightStopRate !== null) ? param.hourlyInternationalNightStopRate.toString() : null;
          this.hourlyDomesticPerDiemRate = (!!param && param.hourlyDomesticPerDiemRate !== null) ? param.hourlyDomesticPerDiemRate.toString() : null;
          this.hourlyInternationalPerDiemRate = (!!param && param.hourlyInternationalPerDiemRate !== null) ? param.hourlyInternationalPerDiemRate.toString() : null;

        	//this.dhtRate = (!!param && param.dhtRate !== null) ? param.dhtRate.toString() : null;
        	//this.heavyFlyingRate = (!!param && param.heavyFlyingRate !== null) ? param.heavyFlyingRate.toString() : null;
          this.maxPayOfficeDutyHoursPerDay = (!!param && param.MaxPayOfficeDutyHoursPerDay !== null) ? param.MaxPayOfficeDutyHoursPerDay.toString() : null;
          this.groundTrainingRatePerDay = (!!param && param.groundTrainingRatePerDay !== null) ? param.groundTrainingRatePerDay.toString() : null;

          this.cabinSupportActivityRate = (!!param && !!param.CabinSupportActivityPerHour) ? Number(param.CabinSupportActivityPerHour) : null;
          this.cabinSpecialDutyRate = (!!param && !!param.CabinSpecialDutyPerHour) ? Number(param.CabinSpecialDutyPerHour) : null;

        	this.lT_LTC_LESS_EXP_Rate = (!!param && param.lT_LTC_LESS_EXP_Rate !== null) ? param.lT_LTC_LESS_EXP_Rate.toString() : null;
        	this.lT_LTC_MORE_EXP_Rate = (!!param && param.lT_LTC_MORE_EXP_Rate !== null) ? param.lT_LTC_MORE_EXP_Rate.toString() : null;
        	this.lT_TRI_MORE_EXP_Rate = (!!param && param.lT_TRI_MORE_EXP_Rate !== null) ? param.lT_TRI_MORE_EXP_Rate.toString() : null;
        	this.lT_TRI_LESS_EXP_Rate = (!!param && param.lT_TRI_LESS_EXP_Rate !== null) ? param.lT_TRI_LESS_EXP_Rate.toString() : null;
        	this.lT_TRE_LESS_EXP_Rate = (!!param && param.lT_TRE_LESS_EXP_Rate !== null) ? param.lT_TRE_LESS_EXP_Rate.toString() : null;
        	this.lT_TRE_MORE_EXP_Rate = (!!param && param.lT_TRE_MORE_EXP_Rate !== null) ? param.lT_TRE_MORE_EXP_Rate.toString() : null;

        	this.sIM_SFI_LESS_EXP_Rate = (!!param && param.sIM_SFI_LESS_EXP_Rate !== null) ? param.sIM_SFI_LESS_EXP_Rate.toString() : null;
        	this.sIM_SFI_MORE_EXP_Rate = (!!param && param.sIM_SFI_MORE_EXP_Rate !== null) ? param.sIM_SFI_MORE_EXP_Rate.toString() : null;
        	this.sIM_TRI_LESS_EXP_Rate = (!!param && param.sIM_TRI_LESS_EXP_Rate !== null) ? param.sIM_TRI_LESS_EXP_Rate.toString() : null;
        	this.sIM_TRI_MORE_EXP_Rate = (!!param && param.sIM_TRI_MORE_EXP_Rate !== null) ? param.sIM_TRI_MORE_EXP_Rate.toString() : null;
        	this.sIM_TRE_MORE_EXP_Rate = (!!param && param.sIM_TRE_MORE_EXP_Rate !== null) ? param.sIM_TRE_MORE_EXP_Rate.toString() : null;
        	this.sIM_TRE_LESS_EXP_Rate = (!!param && param.sIM_TRE_LESS_EXP_Rate !== null) ? param.sIM_TRE_LESS_EXP_Rate.toString() : null;

        	this.mFTD_MORE_EXP_Rate = (!!param && param.mFTD_MORE_EXP_Rate !== null) ? param.mFTD_MORE_EXP_Rate.toString() : null;
        	this.mFTD_LESS_EXP_Rate = (!!param && param.mFTD_LESS_EXP_Rate !== null) ? param.mFTD_LESS_EXP_Rate.toString() : null;

        	this.airPortSbyRate = (!!param && param.airPortSbyRate !== null) ? param.airPortSbyRate.toString() : null;
        	this.leaveDays = (!!param && param.leaveDays !== null) ? param.leaveDays.toString() : null;
        	this.sod = (!!param && param.sod !== null) ? param.sod.toString() : null;
        	this.adHocPay = (!!param && param.adHocPay !== null) ? param.adHocPay.toString() : null;

        	this.version = (!!param && (!!param.version || param.version == 0 )) ? param.version : null;
        }

        return {
            PersonalInfoDTO: function () {
                return new personalInfoDTO();
            },
            CrewInfoDTO: function () {
                return new crewInfoDTO();
            },
            EmploymentInfoDTO:function () {
                return new employmentInfoDTO();
            },
            WebAccessDTO: function () {
                return new webAccessDTO();
            },
            PasswordInfoDTO: function () {
                return new passwordInfoDTO()
            },
            PrimaryContactDTO: function () {
                return new primaryContactDTO();
            },
            SecondaryContactDTO: function () {
                return new secondaryContactDTO();
            },
            KinContactDTO: function () {
                return new kinContactDTO();
            },
            TraineeTypeInfoDTO: function () {
                return new traineeTypeInfoDTO();
            },
            FleetExperienceDTO: function () {
                return new fleetExperienceDTO();
            },
          crewDateRangeForPositionDTO: function () {
                return new crewDateRangeForPositionDTO();
            },
          crewBaseAssignmentDTO: function () {
            return new crewBaseAssignmentDTO();
          },
          crewACMIAssignmentDTO: function () {
            return new crewACMIAssignmentDTO();
          },
            CrewUpgradeDTO: function () {
                return new crewUpgradeDTO();
            },
            CrewTrainingStageDTO: function () {
              return new crewTrainingStageDTO();
            },
            HoursDataDTO: function () {
                return new hoursDataDTO();
            },
            preferenceDataDTO: function () {
                return new preferenceDataDTO();
            },
            CrewDefaultValidationDTO : function(params){
                return new  crewDefaultValidationDTO(params);
            },
            importHoursDataDTO : function (){
            	return new importHoursDataDTO();
            },
            ceateLanguageDTO : function (code,name) {
              return new languageSkillDTO(code,name);
            },
            createLanguageSkillDTO : function () {
              return new LanguageSkill();
            },
            getFlyRangePaymentDetail : function () {
            	return new FlyRangePaymentDetail();
            },
            setFlyRangePaymentDetail : function (param) {
            	return new FlyRangePaymentDetail(param);
            },
            setFlyRangePaymentDeleteRq : function(param){
            	return new FlyRangePaymentDeleteRq(param);
            },
            setCrewOtherPaymentDetail : function(param){
            	return new CrewOtherPaymentDetail(param);
            },
            setCrewOtherPaymentDetailRQ : function(param){
            	return new CrewOtherPaymentDetailRQ(param);
            },
            editSaveACMIRangesRequestDTO : function () {
              return new editSaveACMIRangesRequestDTO();
            },
            deleteACMIRangesRequestDTO : function () {
              return new deleteACMIRangesRequestDTO();
            }

        };
    }
}());
